export const privacyPolicyHtml = /*html*/`
`;